export const ApiResult = {
    Success: 0,
    Error: 1,
    CustomError: 2,
};
export const NoImageFileUrl = "/img/big%20bell/noimage.jpg";

export const LanguageEN = 9;
export const LanguageJP = 127;

export const DateTimeFormat = "YYYY/MM/DD HH:mm:ss";
export const DateTimeFormat2 = "YYYYMMDDHHmmss";
export const DateFormat = "YYYY/MM/DD";
export const ZAIKOYMFormat = "YYYYMM";

export const CSVDateFormat = "YYYYMMDDHHmmssSSS";

export const OrientationX = "horizontal";

export const PARAM = {
    IRAINO: "i",
}

export const ControlKBN = {
    DISABLED: 0,
    ENABLED: 1,
    ADMIN: 2,
    // Special Values
    ALLUSERS: 3,
    ADMINONLY: 4
};

export const ShukaKBN = {
    NORMAL: '1',
    REGULAR: '2',
}

export const UserType = {
    GENERAL: "1",
    POWERUSER: "2",
    ADMINISTRATOR: "3"
}

export const SessionData = {
    NEWIRAIFORM: "newiraiform",
    NEWVHANSOKULIST: "newhansokulist",
    NEWIRAINO: "newiraino",

    UPDIRAINO: "updateiraino",
    UPDIRAIFORM: "updateiraiform",
    UPDVHANSOKULIST: "updatehansokulist",

    DELIRAINO: "deleteiraino",
    DELIRAINOREG: "deleteirainoreg",

    VIEWIRAINO: "viewiraino",
    VIEWIRAINOREG: "viewirainoreg",

    WEBAUTH: "webAuth",
    INVENTORYDETAILS: "whn0102",
    WSP0201AUTH: "wsp0201Auth"
};

export const RadioSelection = {
    ALL: null,
    SELECTED: true,
    UNSELECTED: false
}

export const OrderByField = {
    CATEGORY: "BunruiCode1",
    HANSOKUCODE: "HansokuCode",
    NYUKADT: "NyukaDt"
}

export const SortOrder = {
    ASC: 0,
    DESC: 1,
}

export const StopFlg = {
    ACCEPTING: "0",
    STOPPED: "1",
    CONFIRMED: "2"
}

export const ResultsByExpense = {
    NONE: 1,
    HANSOKU: 2,
    DETAILS: 3
}

export const ScreeName = {
    WSP0202: "WSP0202",
    WSP0203: "WSP0203",
    WHN0101: "WHN0101",
    WHN0102: "WHN0102",
    WDT0101: "WDT0101",
}

export const ScreenAuthType = {
    HIDE: "0",
    ALL: "1",
    POWERUSERS: "2",
    ADMIN: "3"
}


// WEBPACK FOOTER //
// ./helpers/const.js